import React, { useEffect, useState, useRef } from 'react'
import moment from 'moment'
import router from '../router'
import axios from '../plugins/axios'
import { checkEmptyValue } from '../plugins/common'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import Toast from '../plugins/useToast'
import { wardState, bedInfoState, wardSuspendState, wardSilenceState, audioPlayState, timeState, demoModeState, hl7InfoStatus } from '../plugins/recoil'
import useSoundActiveFromAudio from "../plugins/useSoundActive";
import highAudio from '../assets/sounds/IEC_high.wav'
import { useTranslation } from 'react-i18next'

import {ReactComponent as IconArrowDown} from '../assets/icons/ic-arrow-down.svg'
import {ReactComponent as IconArrowUp} from '../assets/icons/ic-arrow-up.svg'
import {ReactComponent as IconAlarmOff} from '../assets/icons/ic-alarm-suspend.svg'
import {ReactComponent as IconAlarmSilence} from '../assets/icons/ic-alarm-silence.svg'
import {ReactComponent as IconAlarmOn} from '../assets/icons/ic-alarm-on.svg'
import {ReactComponent as IconCheckBlue} from '../assets/icons/ic-check-blue.svg'
import {ReactComponent as IconUser} from '../assets/icons/ic-user.svg'
import {ReactComponent as LogoImage } from '../assets/img/logo.svg';
import {ReactComponent as IconDelete} from '../assets/icons/ic-delete-dash.svg';
import {ReactComponent as IconDeleteHover} from '../assets/icons/ic-delete-dash-hover.svg';
import {ReactComponent as IconSpeechTail} from '../assets/icons/ic-speech-bubble-tail.svg';
import {ReactComponent as IconPatientSearch} from '../assets/icons/ic-patient-search.svg'
import {ReactComponent as IconKebab} from '../assets/icons/ic-kebab.svg'

import {ReactComponent as IconSuccess} from '../assets/icons/ic-success.svg'
import {ReactComponent as IconError} from '../assets/icons/ic-error.svg'

import './Header.scss'
const Header = ({ handleChangeWard, onSettingsClick, onLeadModalClick, onUserInfoClick, onUserSettingClick, onSearchClick, onLogoutClick, handleChangeWardStatus, wardStatusChangeFlag ,curMonitor,handleCurMonitor,onOpenDeepSightInfo}) => {
    const isFirstRender = useRef(true); 
    const { t, i18n } = useTranslation()    
    const [alarmActive, setAlarmActive] = useState(false)
    const [time, setTime] = useRecoilState(timeState)
    const [roomArr, setRoomArr] = useState([])
    const [curWard, setCurWard] = useRecoilState(wardState)
    const [room, setRoom] = useState({ value: '1', label: '중환자실' })
    const [isRoomDropdownShow, setIsRoomDropdownShow] = useState(false)
    const [bedInfo, setBedInfo] = useRecoilState(bedInfoState)
    const [wardSuspend, setWardSuspend] = useRecoilState(wardSuspendState);
    const [silenceInfo, setSilenceInfo] = useRecoilState(wardSilenceState);
    const [isDemoMode, ] = useRecoilState(demoModeState);    
    const roomDropdownOpenRef = useRef(null)
    const roomDropdownRef = useRef(null)
    const [isAlarmDropdownShow, setIsAlarmDropdownShow] = useState(false);
    const alarmDropdownOpenRef = useRef(null)
    const alarmDropdownRef = useRef(null)
    const alarmOptions = [
        { value: "0", label: 'header.alarmOn', icon: <IconAlarmOn /> },
        { value: "1", label: 'header.alarmOff', icon: <IconAlarmOff /> },
        { value: "2", label: 'header.alarmPause', icon: <IconAlarmSilence /> }
    ];
    const [isUserDropdownShow, setIsUserDropdownShow] = useState(false)
    const [isSettingDropdownShow, setIsSettingDropdownShow] = useState(false)
    const userDropdownOpenRef = useRef(null)
    const userDropdownRef = useRef(null)
    const settingDropdownOpenRef = useRef(null)
    const settingDropdownRef = useRef(null)
    const [userInfo, setUserInfo] = useState({ name: '홍길동' })
    const [currentAlarmObj, setCurrentAlarmObj] = useState(alarmOptions[0])
    const [playAudio, setPlayAudio] = useRecoilState(audioPlayState);
    const setSilenceState = useSetRecoilState;
    const [dashboards, setDashboards] = useState([]);
    const [isDashHover, setIsDashHover] = useState(null);
    const [isDeleteBtnHover, setIsDeleteBtnHover] = useState(null);    
    const [isDashConfirm, setIsDashConfirm] = useState(null)
    const [hl7Info, ] = useRecoilState(hl7InfoStatus)
    const [showHl7Status, setShowHl7Status] = useState(false)
    // const { isSounding, play, pause } = useSoundActiveFromAudio(highAudio)

    const getTimeFormat = () => {
        const lang = i18n.language;
        if (lang === 'ko') return 'YYYY-MM-DD A hh:mm:ss'
        if (lang === 'it') return 'DD/MM/YYYY HH:mm:ss';
        return 'YYYY-MM-DD A h:mm:ss'; // en, pl 등
    };

    const getWardList = async () => {
        try {
            const res = await axios.get('/wards')
            if (res.code != '200') throw res
            setRoomArr(res.data.content.map(item => { return { value: item.id, label: item.name, code: item.code } }))
            if (res.data.content.length > 0) {
                const firstWard = { value: res.data.content[0].id, label: res.data.content[0].name, code: res.data.content[0].code }
                setRoom(firstWard)
                handleChangeWard(firstWard)
                setCurWard(firstWard)
            }
        } catch (err) {
            console.warn(err)
        }
    }

    const getServerTime = async () => {
        try {
            const res = await axios.get(`/system/time`)
            if (res.code != '200') throw res
            setTime(moment(res.data.currentTime))
        } catch (err) {
            console.warn(err)
        }
    }

    const handleAlarmChange = async (newValue) => {
        // 서버 실패 여부 상관없이 우선 UI 상태변경
        localStorage.setItem('wardSuspend', newValue)
        setWardSuspend(newValue);
        handleChangeWardStatus()
        // 병동 Silence("2") 일 때, wardSilenceState도 초기화
        if (newValue === "2") {
            setSilenceInfo((prev) => ({
                ...prev,
                isSilenced: true,
                startTime: Date.now(),
                remainingSeconds: 120,
            }));
        } else {
            // On("0") or Off("1")이면 병동 Silence 해제
            setSilenceInfo({
                isSilenced: false,
                startTime: null,
                remainingSeconds: null,
            })
        }
        handleBedInfoSilence(newValue, true)
    };
    
    const handleBedInfoSilence = (newValue, isFromDropdown) => {
        setBedInfo((prevBedInfo) =>
            prevBedInfo.map((column) =>
                column.map((bed) => {
                    return {
                        ...bed,
                        suspended: bed.suspended !== undefined ? bed.suspended : (isFromDropdown ? (newValue === "1" ? true : false) : false),
                        alarmSilence: newValue === "2" ? '1' : '0',
                    }
                })
            )
        );

        const isHalf = localStorage.getItem('cnt') || false
        if (isHalf) {
            const oldFullDashboardBedInfo = JSON.parse(localStorage.getItem('bedInfo'))
            if (oldFullDashboardBedInfo) {
                const newFullDashboardBedInfo = oldFullDashboardBedInfo.map((group) => {
                    return group.map((item) => {
                        return {
                            ...item,
                            suspended: item.suspended !== undefined ? item.suspended : (isFromDropdown ? (newValue === "1" ? true : false) : false),
                            alarmSilence: newValue === "2" ? '1' : '0',
                        };
                    });
                });
                localStorage.setItem('bedInfo', JSON.stringify(newFullDashboardBedInfo))
            }
        }
    }

    const handleClickOutside = event => {
        if (roomDropdownOpenRef.current && roomDropdownOpenRef.current.contains(event.target)) {
            return
        }
        if (roomDropdownRef.current && !roomDropdownRef.current.contains(event.target)) {
            setIsRoomDropdownShow(false)
        }

        if (alarmDropdownOpenRef.current && alarmDropdownOpenRef.current.contains(event.target)) {
            return
        }
        if (alarmDropdownRef.current && !alarmDropdownRef.current.contains(event.target)) {
            setIsAlarmDropdownShow(false)
        }

        if (settingDropdownOpenRef.current && settingDropdownOpenRef.current.contains(event.target)) {
            return
        }
        if (settingDropdownRef.current && !settingDropdownRef.current.contains(event.target)) {
            setIsSettingDropdownShow(false)
        }

        if (userDropdownOpenRef.current && userDropdownOpenRef.current.contains(event.target)) {
            return
        }
        if(userDropdownRef.current && !userDropdownRef.current.contains(event.target)) {
            setIsUserDropdownShow(false)
        }
    }

    const handleOpenUserInfo = async () => {
        try {
            // 내 정보 get
            const res = await axios.get('/user/me')
            if (res.code != '200') throw res
            setUserInfo({ ...res.data })
            setIsUserDropdownShow(!isUserDropdownShow)
            setIsAlarmDropdownShow(false)
            setIsRoomDropdownShow(false)
            setIsSettingDropdownShow(false)
        } catch (err) {
            setUserInfo({ name: '' })
            Toast({ isSuccess: false , msg : t('error.failGetUserInfo') });
        }
    }

    const fetchDashboardList = async () => {
        try {
            const wardId = curWard.value === "ICU" ? 1 : curWard.value;
            let res;
            res = await axios.get(`/ward/${wardId}/dashboard/settings`);
            if (res.code !== 200) return;

            //만약 데이터가 하나도 없으면 put을 하고 다시 재 검색.
            if(res.data.length === 0){
                res = await handleCreateDashboard(1);
            }

            setDashboards(Array.isArray(res.data) ? res.data : []);
        } catch (err) {
            console.warn(err)
        }
    };

    const handleCreateDashboard = async (dashNum) => {
        const putPayload = {
            displayOrder: dashNum,
            leftBedCount: 8,
            rightBedCount: 8,
            bedTextSize: 'SMALL',
            waveParameterColors: [],
            numericParameterColors: [],
            devices: []
        };
        try {
            const res = await axios.put(`/ward/${curWard.value}/dashboard/setting/${dashNum}`, putPayload);
            fetchDashboardList();
            handleCurMonitor(dashNum); // 새로 생성된 dash 활성화
            return res;
        } catch (error) {
            console.error(error);
        }
    };

    // ✅ 대시보드 값 체크
    const handleChkDelDashBoard = (dashNum) => {       
        let deviceIdCount = 0;
        
        //현재 보고 있는 대시보드일 경우는 BedInfo를 참고, 아닌 경우는 기존에 dashboards에서 확인.
        if(curMonitor == dashNum){
            deviceIdCount = (bedInfo?.flat?.() ?? []).filter(bed => !!bed.deviceId).length;
        }else {                        
            const dashboard = dashboards.find(d => d.displayOrder === dashNum);  
            deviceIdCount = dashboard.devices?.length;   
        } 

        if(deviceIdCount > 0){
            setIsDashConfirm(dashNum)
        }
        else{
            handleDeleteDashboard(dashNum)
        }
    }

    // ✅ 대시보드 삭제 핸들러
    const handleDeleteDashboard = async (dashNum) => {    
        const wardId = curWard.value === "ICU" ? 1 : curWard.value;    
        try {
            await axios.delete(`/ward/${wardId}/dashboard/setting/${dashNum}`);
            fetchDashboardList();
            setIsDashConfirm(null);
            if (curMonitor === dashNum) {
                handleCurMonitor(1);
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        const hasConnected = hl7Info?.connections?.some(conn => conn.connected);
        if (hasConnected && !showHl7Status) {
            setShowHl7Status(true);
        }
    }, [hl7Info, showHl7Status]);

    useEffect(() => {        
        getServerTime()  
        const timer = setInterval(() => {
            setTime(prevTime => prevTime.clone().add(1, 'second'))
        }, 1000)

        const syncTimer = setInterval(() => {
            getServerTime()
        }, 60000)

        getWardList()
        const curWardSuspend = localStorage.getItem('wardSuspend')
        if (curWardSuspend) {
            setWardSuspend(curWardSuspend)
            if (curWardSuspend === "2") {
                setSilenceInfo((prev) => ({
                    ...prev,
                    isSilenced: true,
                    startTime: Date.now(),
                    remainingSeconds: 120,
                }));
            } else {
                // On("0") or Off("1")이면 병동 Silence 해제
                setSilenceInfo({
                    isSilenced: false,
                    startTime: null,
                    remainingSeconds: null,
                })
            }
            handleBedInfoSilence(curWardSuspend, true)
        } else {
            setWardSuspend('0')
            setSilenceInfo({
                isSilenced: false,
                startTime: null,
                remainingSeconds: null,
            })
        }
        // 더미 오디오 객체를 생성하여 실제 재생 권한을 획득
        const enableAudio = async () => {
            try {
                // 실제 오디오 파일을 사용하여 테스트
                const audio = new Audio(highAudio);
                audio.volume = 0; // 무음으로 재생
                audio.muted = true; // 완전 무음
                
                // 짧은 시간만 재생 후 정지
                const playPromise = audio.play();
                if (playPromise !== undefined) {
                    await playPromise;
                    setTimeout(() => {
                        audio.pause();
                        audio.currentTime = 0;
                    }, 100);
                }
                
                setPlayAudio(true);
                localStorage.setItem('hasUserInteracted', 'true');
                console.log('Audio enabled successfully');
            } catch (error) {
                console.log('Audio autoplay blocked, waiting for user interaction');
                // 실패해도 계속 진행
            }
        };

        const handleFirstInteraction = async () => {
            try {
                // 사용자 상호작용 시 다시 시도
                const audio = new Audio(highAudio);
                audio.volume = 0;
                audio.muted = true;
                
                await audio.play();
                setTimeout(() => {
                    audio.pause();
                    audio.currentTime = 0;
                }, 100);
                
                setPlayAudio(true);
                localStorage.setItem('hasUserInteracted', 'true');
                console.log('Audio enabled after user interaction');
            } catch (error) {
                console.warn('Still failed to enable audio:', error);
            }
            
            window.removeEventListener('click', handleFirstInteraction);
            window.removeEventListener('keydown', handleFirstInteraction);
        };

        const hasUserInteracted = localStorage.getItem('hasUserInteracted');
        if (!hasUserInteracted) {
            window.addEventListener('click', handleFirstInteraction);
            window.addEventListener('keydown', handleFirstInteraction);
        } else {
            // 이미 상호작용이 있었다면 다시 권한 확인
            enableAudio();
        }

        window.addEventListener('mousedown', handleClickOutside);

        return () => {
            clearInterval(timer)
            clearInterval(syncTimer)
            window.removeEventListener('click', handleFirstInteraction)
            window.removeEventListener('keydown', handleFirstInteraction)
            window.removeEventListener('mousedown', handleClickOutside);
        }
    }, [])

    //Demo Mode 변경 감지 후 1로 초기화 
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        getWardList();
    }, [isDemoMode])

    useEffect(() => {
        let intervalId = null;
    
        if (silenceInfo.isSilenced) {
            intervalId = setInterval(() => {
                setSilenceInfo(prev => {
                    if (!prev.remainingSeconds) return prev;
                    const nextRemaining = prev.remainingSeconds - 1;
                    return { ...prev, remainingSeconds: nextRemaining };
                });
            }, 1000);
        } else if (!silenceInfo.isSilenced) {
            // Silence 상태가 아니면 기존 타이머 초기화
            if (intervalId) clearInterval(intervalId);
        }
    
        return () => {
            if (intervalId) clearInterval(intervalId);
        };
    }, [silenceInfo.isSilenced, curWard.value, setSilenceInfo, setWardSuspend]);        

    useEffect(() => {
        if (silenceInfo.isSilenced && silenceInfo.remainingSeconds <= 0) {
            setWardSuspend("0");
            setSilenceInfo({
                isSilenced: false,
                startTime: null,
                remainingSeconds: null,
            });
            handleBedInfoSilence("0");
            localStorage.setItem('wardSuspend', '0');
        }
    }, [silenceInfo.remainingSeconds, silenceInfo.isSilenced])

    useEffect(() => {
        setCurrentAlarmObj(alarmOptions.find(option => option.value === wardSuspend) || alarmOptions[0])
    }, [wardSuspend])

    // ✅ DashBoard 변경 시 Dashboard 리스트 새로 불러옴.
    useEffect(() => {
        if (curWard) fetchDashboardList();
    }, [curWard,curMonitor]);  
    
    useEffect(() => {
        // locale 변경에 따라 moment locale도 변경
        const currentLanguage = i18n.language        
        moment.locale(currentLanguage)
        setTime(prevTime => prevTime.clone().locale(currentLanguage))
    }, [i18n.language])

    return (
        <div className="flex items-center px-4 py-2" style={{ backgroundColor: '#1F1F1F', width: '100%', minWidth: 800, height: 40 }}>
            <LogoImage className='w-[200px] mr-[20px]'/>
            <div ref={alarmDropdownOpenRef} className="relative flex items-center mr-[6px] text-white cursor-pointer" onClick={() => { setIsAlarmDropdownShow(!isAlarmDropdownShow); setIsRoomDropdownShow(false); setIsUserDropdownShow(false); setIsSettingDropdownShow(false) }} style={{ padding: '5px 8px', width: 152, height: 28, borderRadius: 6, border: '1px solid #5E5E5E', boxShadow: '0px 4px 4px 0px #00000066', background: 'linear-gradient(180deg, #5E5E5E 0%, #383838 100%)'}}>
                <div className="flex items-center" style={{ gap: 4 }}>
                    {currentAlarmObj.value === "2" ? (
                        <div className="relative flex items-center justify-center">
                        <IconAlarmSilence />
                        {silenceInfo.remainingSeconds !== null && (
                            <span className="absolute text-[14px] text-[#DBFF00] font-medium "
                            style={{ top: '50%', left: '50%', transform: 'translate(-50%, -50%)', textShadow: `
                                -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000`,}}>
                            {silenceInfo.remainingSeconds}
                            </span>
                        )}
                        </div>
                    ) : (
                        currentAlarmObj.icon
                    )}
                    <span style={{ fontWeight: 300 }}>{t(currentAlarmObj.label)}</span>
                </div>
                {isAlarmDropdownShow ? <IconArrowUp className="ml-auto"/> : <IconArrowDown className="ml-auto"/>}
                {
                    isAlarmDropdownShow &&
                    <div ref={alarmDropdownRef} className="absolute bg-[#1F1F1F] rounded-[6px]" style={{ width: 152, top: 30, left: 0, zIndex: 9999, padding: '8px 0', border: '1px solid #5E5E5E', boxShadow: '0px 12px 12px 0px #00000099' }}>
                        {
                            alarmOptions.map((option, idx) => {
                                return (
                                    <div
                                        key={`alarm-list-item-${idx}`}
                                        className="flex items-center px-2"
                                        style={{ height: 32, color: option.value === wardSuspend ? '#3182F7' : '#fff', fontWeight: 300, cursor: 'pointer', gap: '4px' }}
                                        onClick={() => {
                                            if (option.value === wardSuspend) return
                                            handleAlarmChange(option.value);
                                            setIsAlarmDropdownShow(false);
                                        }}
                                    >
                                        {option.icon}
                                        {t(option.label)}
                                        {
                                            option.value === wardSuspend &&
                                            <IconCheckBlue className="ml-auto"/>
                                        }
                                    </div>
                                )
                            })
                        }
                    </div>
                }
            </div>
            {/* <Dropdown options={roomArr} value={room} placeholder={'병동 선택'} handleChange={(e) => { handleChangeWard(e) }} customBorderRadius={6} customWidth={256} customHeight={28} customBorderColor={'#5E5E5E'} className={'cursor-pointer bg-gradient-to-b from-[#5E5E5E] to-[#1F1F1F] mr-2'}/> */}
            
            <div className="w-[200px] px-2 flex items-center mr-[6px] bg-[#343434] cursor-pointer" onClick={() => { onSearchClick() }} style={{ borderRadius: 6, border: '1px solid #444444',minHeight: 28, maxHeight: 28 }}>
                <div className="font-light text-[#DEDEDE] opacity-30" style={{ fontSize: 16 }}>{t('header.search')}</div>
                <IconPatientSearch className="ml-auto" />
            </div>
            <div ref={settingDropdownOpenRef} onClick={() => { setIsSettingDropdownShow(!isSettingDropdownShow); setIsRoomDropdownShow(false); setIsAlarmDropdownShow(false); setIsUserDropdownShow(false); }} className="flex items-center justify-center relative rounded-[6px] bg-gradient-to-b from-[#5E5E5E] to-[#383838] cursor-pointer" style={{ width: 28, height: 28, border: '1px solid #5E5E5E', boxShadow: '0px 4px 4px 0px #00000066' }}>
                <IconKebab />
                {
                    isSettingDropdownShow &&
                    <div className="relative" style={{ left: -45 }}>
                        {/* 삼각형 화살표 */}
                        <div className="absolute transform -translate-x-1/2 z-20" style={{ zIndex: 10000, top: 12, left: 36 }}>
                            <div className="w-0 h-0 border-l-[8px] border-r-[8px] border-b-[10px] border-l-transparent border-r-transparent border-b-[#5E5E5E]"></div>
                            <div className="w-0 h-0 border-l-[7px] border-r-[7px] border-b-[9px] border-l-transparent border-r-transparent border-b-[#1F1F1F] absolute left-1/2 transform -translate-x-1/2 top-[1px]"></div>
                        </div>
                        <div ref={settingDropdownRef} className="absolute bg-[#1F1F1F] rounded-[6px] text-white text-center" style={{ width: 180, top: 20, left: -56, zIndex: 9999, padding: '8px 0', border: '1px solid #5E5E5E', boxShadow: '0px 12px 12px 0px #00000099' }}>
                            <div className="h-[32px] cursor-pointer content-center font-light" style={{ fontSize: 16 }} onClick={() => { setIsSettingDropdownShow(false); onSettingsClick() }}>{t('header.setup')}</div>
                            <div className="my-1 h-[1px] w-full bg-[#444444]" />
                            <div className="h-[32px] cursor-pointer content-center font-light" style={{ fontSize: 16 }} onClick={() => { setIsSettingDropdownShow(false); onLeadModalClick()  }}>{t('header.leadModalOpen')}</div>
                        </div>
                    </div>
                }
            </div>             
            <div className='flex ml-auto gap-[20px]'>
                {
                    (isDemoMode == true || isDemoMode == "true") && (
                        <div className='flex justify-center items-center w-[155px] h-[40px] bg-[#FFF500]'>
                            <span className='text-[#FF002E] text-[20px] font-semibold leading-[110%] blink' style={{ fontFamily: '"Roboto Condensed", sans-serif' }}>Demo Mode</span>
                        </div>
                    )
                }                
                {/* hl7 Connect */}
                {showHl7Status && (
                    <div className='flex justify-center items-center h-[40px] gap-[4px]'>
                        {hl7Info?.connections?.some(conn => conn.connected) ? (
                            <>
                                <IconSuccess className='w-[20px] h-[20px] mr-[4px]'/>
                                <span className='text-[#146830] text-[16px] font-pretendard font-light leading-[110%]'>
                                    {t('header.emrConnected')}
                                </span>
                            </>
                        ) : (
                            <>
                                <IconError className='w-[20px] h-[20px] mr-[4px]'/>
                                <span className='text-[#FF002E] text-[16px] font-pretendard font-light leading-[110%]'>
                                    {t('header.emrDisconnected')}
                                </span>
                            </>
                        )}
                    </div>
                )}
            </div>

            <div className="flex items-center h-full ml-auto gap-3">
                <div ref={roomDropdownOpenRef} className="relative flex items-center text-white cursor-pointer" onClick={() => { setIsRoomDropdownShow(!isRoomDropdownShow); setIsAlarmDropdownShow(false); setIsUserDropdownShow(false); setIsSettingDropdownShow(false) }} style={{ padding: '5px 8px', width: 175, height: 28, borderRadius: 6, border: '1px solid #5E5E5E', boxShadow: '0px 4px 4px 0px #00000066', background: 'linear-gradient(180deg, #5E5E5E 0%, #383838 100%)'}}>
                    <span className="truncate w-full block" style={{ fontWeight: 300, maxWidth: 120 }} title={room.label}>
                        {room.label}
                    </span>
                    {
                        isRoomDropdownShow ? <IconArrowUp className="ml-auto"/> : <IconArrowDown className="ml-auto"/>
                    }
                    {
                        isRoomDropdownShow &&
                        <div ref={roomDropdownRef} className="absolute bg-[#1F1F1F] rounded-[6px]" style={{ width: 175, top: 30, left: 0, zIndex: 9999, padding: '8px 0', border: '1px solid #5E5E5E', boxShadow: '0px 12px 12px 0px #00000099' }}>
                            {
                                roomArr.map((roomItem, idx) => {
                                    return (
                                        <div 
                                            onClick={() => { 
                                                setRoom(roomItem)
                                                handleChangeWard(roomItem)
                                                setCurWard(roomItem)
                                            }}
                                            className="flex items-center px-2 room-list-item"
                                            key={`room-list-item-${idx}`}
                                            style={{ height: 32, color: roomItem.label === room.label ? '#3182F7' : '', fontWeight: 300 }}>
                                            <span className="truncate w-full block" style={{ maxWidth: 120 }} title={roomItem.label}>
                                                {roomItem.label}
                                            </span>
                                            {
                                                roomItem.label === room.label &&
                                                <IconCheckBlue className="ml-auto"/>
                                            }
                                        </div>
                                    )
                                })
                            }
                        </div>
                    }
                </div>
                {/* <div className="text-white" onClick={() => { setPlayAudio(true) }}>{`Autoplay ${playAudio ? 'enable' : 'boom'}`}</div> */}
                <div className="flex flex-nowrap relative rounded">
                    {[1, 2, 3].map((dashNum) => {
                        const dashboard = dashboards.find(d => d.displayOrder === dashNum);
                        //console.log('dashboards', dashboards);
                        const exists = !!dashboard;
                        return exists ? (
                            <div
                                key={dashNum}
                                className="flex items-center justify-center"
                                onMouseEnter={() => setIsDashHover(dashNum)}
                                onMouseLeave={() => setIsDashHover(null)}
                                style={{ display: 'inline-block' }}
                            >
                                <div
                                    //className={`${curMonitor !== dashNum ? 'cursor-pointer border border-transparent bg-[#2C2C2C] text-[#969696]' : 'rounded cursor-default pointer-events-none border-[#5E5E5E] bg-gradient-to-b from-[#5E5E5E] to-[#383838] '} flex items-center justify-center w-[78px] h-[28px] px-[8px] py-[7px] gap-2 flex-1 border border-[#5E5E5E] shadow-[0_4px_4px_0_rgba(0,0,0,0.25)] text-white font-pretendard text-[14px] font-light leading-[110%] relative`}
                                    className={`${(isDashConfirm === dashNum || curMonitor !== dashNum) ? 'cursor-pointer border border-transparent bg-[#2C2C2C] text-[#969696]' : 'rounded pointer-events-none border-[#5E5E5E] bg-gradient-to-b from-[#5E5E5E] to-[#383838] '} flex items-center justify-center w-[78px] h-[28px] px-[8px] py-[7px] gap-2 flex-1 border border-[#5E5E5E] shadow-[0_4px_4px_0_rgba(0,0,0,0.25)] text-white font-pretendard text-[14px] font-light leading-[110%] relative`}
                                    onClick={() => { handleCurMonitor(dashNum); setIsDashConfirm(null); }}
                                    onMouseMove={e => {
                                        const rect = e.currentTarget.getBoundingClientRect();
                                        const x = e.clientX - rect.left;
                                        if (x > rect.width * (2/3)) {
                                            setIsDeleteBtnHover(dashNum);
                                        } else {
                                            setIsDeleteBtnHover(null);
                                        }
                                    }}
                                    onMouseLeave={() => setIsDeleteBtnHover(null)}
                                >
                                    {t('header.dash')}{dashNum}
                                    {/* {isDashHover === dashNum && dashNum !== 1 && (
                                        <button
                                            className="z-20 size-[14px] absolute top-[6px] right-[3px] bg-transparent p-0"
                                            style={{ pointerEvents: 'auto' }}
                                            onClick={e => { e.stopPropagation(); handleDeleteDashboard(dashNum); }}
                                            tabIndex={-1}
                                        >
                                            {isDeleteBtnHover === dashNum ? <IconDeleteHover className="size-[14px]" /> : <IconDelete className="size-[14px]" />}
                                        </button>                                
                                    )} */}
                                    {(isDashConfirm === dashNum || isDashHover === dashNum) && dashNum !== 1 && (
                                        <div className='absolute top-[6px] right-[3px]'>
                                            <button
                                                className="z-20 size-[14px] bg-transparent p-0"
                                                style={{ pointerEvents: 'auto' }}
                                                onClick={e => { e.stopPropagation(); handleChkDelDashBoard(dashNum); }}
                                                tabIndex={-1}
                                            >
                                                {(isDeleteBtnHover === dashNum || isDashConfirm === dashNum) ? <IconDeleteHover className="size-[14px]" /> : <IconDelete className="size-[14px]" />}
                                            </button>
                                            {
                                                isDashConfirm === dashNum && (
                                                    <div className='absolute left-1/2 top-[30px] z-[9999] translate-x-[-50%]' style={{zIndex: 9999}} onClick={(e) => e.stopPropagation()}>
                                                        <IconSpeechTail className='absolute left-1/2 w-full translate-x-[-50%] -top-[10px]'/>
                                                        <div className='flex flex-col w-[260px] px-[16px] py-[12px] items-start rounded-[6px] bg-[#DEDEDE] shadow-[0px_12px_12px_0px_rgba(0,0,0,0.60)]'>
                                                            <strong className='mb-[8px] text-[#000] font-pretendard text-[14px] font-medium leading-[110%]'>{t('header.deleteDashboard', { dashNum })}</strong>
                                                            <p className='text-[#000] font-pretendard text-[14px] font-normal leading-[110%] mb-[16px]'>
                                                                {t('header.deleteDashboardMessage')}
                                                            </p>
                                                            <div className='w-full flex justify-end gap-[8px] items-center'>
                                                                <button className='flex justify-center w-[88px] h-[28px] px-[8px] py-[7px] !cursor-pointer items-center rounded-[6px] border border-[#B8B8B8] bg-gradient-to-b from-[#FFF] to-[#DEDEDE] text-[#000] font-pretendard text-[16px] font-light leading-[110%]'
                                                                    onClick={(e) => {
                                                                        e.stopPropagation()
                                                                        setIsDashConfirm(null);}
                                                                    }                                                        
                                                                >
                                                                    {t('header.cancel')}
                                                                </button>
                                                                <button className='flex justify-center w-[88px] h-[28px] px-[8px] py-[7px] !cursor-pointer items-center rounded-[6px] border border-[#5E5E5E] bg-gradient-to-b from-[#5E5E5E] to-[#383838] font-pretendard text-[16px] font-light leading-[110%] text-[#FFF]'
                                                                    onClick={(e) => {
                                                                        e.stopPropagation()
                                                                        handleDeleteDashboard(dashNum);}
                                                                    }
                                                                >
                                                                    {t('header.delete')}
                                                                </button>
                                                            </div>
                                                        </div>                                            
                                                    </div>
                                                )
                                            }                                        
                                        </div>                                    
                                    )}
                                </div>
                            </div>
                        ) : (
                            <button
                                key={dashNum}
                                className={`${curMonitor !== dashNum ? 'cursor-pointer border border-transparent bg-[#2C2C2C] text-[#969696]' : 'rounded cursor-default pointer-events-none border-[#5E5E5E] bg-gradient-to-b from-[#5E5E5E] to-[#383838] '} flex items-center justify-center w-[78px] h-[28px] px-[8px] gap-2 flex-1 border shadow-[0_4px_4px_0_rgba(0,0,0,0.25)] text-white font-pretendard text-[22px] font-light leading-[110%]`}
                                onClick={() => handleCreateDashboard(dashNum)}
                            >+</button>  
                        );
                    })}
                </div>          
                <div className="w-[1px] h-full bg-[#444444]"/>      
                <div className="relative">
                    <IconUser ref={userDropdownOpenRef} className="cursor-pointer" onClick={() => { handleOpenUserInfo() }}/>
                    {
                        isUserDropdownShow &&
                        <div className="relative">
                            {/* 삼각형 화살표 */}
                            <div className="absolute left-1/2 transform -translate-x-1/2 -top-[6px]" style={{ zIndex: 10000 }}>
                                <div className="w-0 h-0 border-l-[8px] border-r-[8px] border-b-[10px] border-l-transparent border-r-transparent border-b-[#5E5E5E]"></div>
                                <div className="w-0 h-0 border-l-[7px] border-r-[7px] border-b-[9px] border-l-transparent border-r-transparent border-b-[#1F1F1F] absolute left-1/2 transform -translate-x-1/2 top-[1px]"></div>
                            </div>                            
                            <div ref={userDropdownRef} className="absolute left-1/2 -translate-x-1/2 w-auto min-w-[140px] bg-[#1F1F1F] rounded-[6px] text-white text-center whitespace-nowrap" style={{ top: 3, zIndex: 9999, padding: '8px 16px', border: '1px solid #5E5E5E', boxShadow: '0px 12px 12px 0px #00000099' }}>
                                <div className="pb-2 h-[32px] content-center font-light" style={{ fontSize: 16, borderBottomWidth: 1, borderColor: '#444444'  }}>{checkEmptyValue(userInfo.name)}</div>
                                <div className="pt-2 h-[32px] cursor-pointer content-center font-light" style={{ fontSize: 16 }} onClick={() => { setIsUserDropdownShow(false); onUserInfoClick() }}>{t('header.userInfo')}</div>
                                <div className="pt-2 h-[32px] cursor-pointer content-center font-light" style={{ fontSize: 16 }} onClick={() => { setIsUserDropdownShow(false); onUserSettingClick() }}>{t('header.settings')}</div>
                                <div className="pt-2 h-[32px] cursor-pointer content-center font-light" style={{ fontSize: 16 }} onClick={() => { setIsUserDropdownShow(false); onOpenDeepSightInfo() }}>{t('header.deepSightInfo')}</div>
                                <div className="pt-2 h-[32px] cursor-pointer content-center text-[#FF002E]" style={{ fontSize: 16 }} onClick={() => { setIsUserDropdownShow(false); onLogoutClick() }}>{t('header.logout')}</div>
                            </div>
                        </div>
                    }
                </div>
                <div className="" style={{ color: 'white', height: '100%', fontWeight: 300, minWidth: 170 }}>
                    { time.format(getTimeFormat()) }
                </div>
            </div>
        </div>
    )
}

export default Header